import { render } from "./Abonos.vue?vue&type=template&id=0b36138c&scoped=true"
import script from "./Abonos.vue?vue&type=script&lang=js"
export * from "./Abonos.vue?vue&type=script&lang=js"

import "./Abonos.vue?vue&type=style&index=0&id=0b36138c&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b36138c"]])

export default __exports__